import { usePageSEO } from '@/hooks/usePageSEO';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import Intro from './components/Intro';
import ComparatifCards from './components/ComparatifCards';
import TableauComparatif from './components/TableauComparatif';
import Signes from './components/Signes';
import PourquoiNous from './components/PourquoiNous';
import Temoignage from './components/Temoignage';
import FAQ from './components/FAQ';
import QuoteForm from './components/QuoteForm';
import CTAFinal from './components/CTAFinal';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Accueil', item: 'https://couvreur-levis.com/' },
    { '@type': 'ListItem', position: 2, name: 'Toiture à Lévis', item: 'https://couvreur-levis.com/toiture-levis' },
  ],
};

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Toiture résidentielle',
  provider: { '@type': 'LocalBusiness', '@id': 'https://couvreur-levis.com/#business' },
  areaServed: { '@type': 'City', name: 'Lévis' },
  description: "Services complets de toiture à Lévis : bardeau, tôle, membrane, toit blanc. Comparatif des matériaux et prix.",
  offers: {
    '@type': 'AggregateOffer',
    priceCurrency: 'CAD',
    lowPrice: '7000',
    highPrice: '85000',
    offerCount: '8',
  },
};

export default function ToiturePage() {
  usePageSEO({
    title: 'Toiture à Lévis | Comparatif Bardeau, Tôle, Membrane',
    description: 'Quel matériau pour votre toiture à Lévis ? Comparatif complet : bardeau, tôle, membrane élastomère. Soumission gratuite en 2h. 418-476-9950.',
    urlPath: '/toiture-levis',
    keywords: 'toiture Lévis, bardeau asphalte, toiture métal, membrane élastomère, comparatif toiture, couvreur',
    ogImage: '/og/og-toiture-levis.jpg',
    ogImageAlt: 'Toiture à Lévis - Comparatif bardeau, tôle, membrane',
    jsonLdSchema: [breadcrumbSchema, serviceSchema],
  });

  return (
    <div className="font-inter min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Intro />
        <ComparatifCards />
        <TableauComparatif />
        <Signes />
        <PourquoiNous />
        <Temoignage />
        <FAQ />
        <QuoteForm />
        <CTAFinal />
      </main>
      <Footer />
    </div>
  );
}